import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import CircularProgressbar from 'react-circular-progressbar'
import { selectors } from 'modules/links'

const QueueProgress = ({ processed, total }) => (
  <div className="circular-progress-wrapper">
    <CircularProgressbar percentage={ total === 0 ? 0 : Math.round(processed * 100 / total) } />
  </div>
)

QueueProgress.propTypes = {
  processed: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
}

const mapStateToProps = createStructuredSelector({
  processed: selectors.getProcessedItemsCount,
  total: selectors.getItemsCount
})

export default connect(mapStateToProps)(QueueProgress)



// WEBPACK FOOTER //
// ./src/components/links/header/warm-progress.js